import {Col, Flex, Row} from 'antd'
import './cards.sass'

export default function CardImageBackground({image, children}) {
  return (
    <div className="card-image-background">
      <div className="background-wrapper">
        <img src={image} alt=""/>
      </div>


      <Row className="card-content" justify="center" align="bottom">
        <Col span={24}>
          {children}
        </Col>
      </Row>

    </div>
  )
}